import { Testimonial } from "../../data/partners";

export const testimonials: Testimonial[] = [
  {
    testimonial:
      "Beautiful space, masses of natural light throughout and the most caring staff who always go the extra mile! Plus the coffee and teas are excellent and unlimited! Unrivaled!",
    companyTitle: "President @ Ground Up Coffee & Tea",
    name: "Ethan Feuer",
    avatar:
      "https://meet-production.s3.us-west-1.amazonaws.com/images/nomadworks/nomadworks-testimonial-5.jpeg",
  },
  {
    testimonial:
      "Nomadworks has been pivotal to my productivity! My dedicated desk means I can have my workstation exactly how I need it to work and the community of like minded entrepreneurs help keep the atmosphere buzzing.",
    companyTitle:
      "VP Commercial Service Delivery and Engineering @ Coranet Corp",
    name: "Tom Waters",
    avatar:
      "https://meet-production.s3.us-west-1.amazonaws.com/images/nomadworks/nomadworks-testimonial-tom.jpeg",
  },
  {
    testimonial:
      "Nomadworks is an outstanding operation. The space has everything you need - generous work areas, a beautiful roof terrace, ‘Safe Spaces’ cleaning protocol, and the best staff! I couldn't rate them more highly.",
    companyTitle: "Partner @ NDNY Architecture + Design PLLC",
    name: "Ananth Robert Sampathkumar",
    avatar:
      "https://meet-production.s3.us-west-1.amazonaws.com/images/nomadworks/nomadworks-testimonial-4.png",
  },
];
